<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router';
import { computed, ref } from 'vue';
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '@/assets/style.scss';
// import Header from '@/components/header/index-bac.vue';
import Menus from '@/components/menus/index.vue';

// import DemoPage from '@/pages/demo-pages/index-bac.vue';
console.log('当前代码已经是最新版本')
//@ts-ignore
const url = new URL(window.location.href)

const route = useRoute();

// 判断当前是否为登录页面
const isLoginPage = computed(() => route.path === '/login');

const menusRef = ref()
const onActionComplete = () => {
  menusRef.value.refreshConsume()
}
</script>

<template>
  <div  v-if="!isLoginPage" class="content">
    <el-config-provider :locale="zhCn">
      <!-- <Header /> -->
      <div class="box-content">
        <Menus ref="menusRef" />
        <div class="route-content">
          <div class="view-container">
            <RouterView @action-complete="onActionComplete"/>
            <!-- <DemoPage></DemoPage> -->
          </div>
        </div>
      </div>
    </el-config-provider>
  </div>
  <div v-else>
    <RouterView />
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/app.scss';
</style>
